document.addEventListener("DOMContentLoaded", () => {
  $(document).on("click", "#ng-reports-export", function(){
    var url = `${window.location.href}/export.xlsx?`
    url += `begin_date=${$("#datatable-filter-begin-date").val()}&`
    url += `end_date=${$("#datatable-filter-end-date").val()}&`

    if ($('#datatable-filter-line').length && $('#datatable-filter-line').val()){
      url += `line=${$('#datatable-filter-line').val()}&`
    }

    if ($('#datatable-filter-product-name').length && $('#datatable-filter-product-name').val()){
      url += `product_name=${$('#datatable-filter-product-name').val()}&`
    }

    if ($('#datatable-filter-internal-part-id').length && $('#datatable-filter-internal-part-id').val()){
      url += `internal_part_id=${$('#datatable-filter-internal-part-id').val()}&`
    }

    if ($('#datatable-filter-customer-part-number').length && $('#datatable-filter-customer-part-number').val()){
      url += `customer_part_number=${$('#datatable-filter-customer-part-number').val()}&`
    }
    window.open(url)
  })
})